/* Retired: this script moved the search modal next to the drawer button for the
   old drawer-nav desktop layout. The header now uses inline links on desktop
   (menu_type_desktop: dropdown), so search stays in the right-hand icons group.
   File kept as a no-op so the script tag in luxury-styles doesn't 404. */
(function() { 'use strict'; })();
